<script>
  export let navigateBack
</script>

<style>
  :global(.back-button__arrow-2xrQUf) {
    cursor: pointer;
    content: url(https://statisc2test.kudobuzz.com/icons/icon-back.svg);
    display: inline-block;
    margin: auto 15px 0 0;
    width: 14px;
    height: 20px;
  }
</style>

<div class="back-button__arrow-2xrQUf" on:click={navigateBack} />
